import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '../fi-dialogs/fi-dialogs-content-base';
import { FiDialogsService } from '../fi-dialogs';
import { AppTextService } from '../app-text';
import { IFiDialogOptions } from '@fi-shared/fi-dialogs/fi-dialogs';
import { IEditObjectDialogData, IEditObjectDialogDataItem } from './fi-edit-object';
import { FiValidatingFormDirective } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.directive';
import { isDefined } from '@fi-shared/utils';
import { FiValuesComparison } from '@fi-shared/utils/fi-values-comparison';
import { Subject } from 'rxjs';

@Component({
    selector: 'fi-edit-object-dialog',
    templateUrl: './fi-edit-object-dialog.component.html',
    styleUrls: ['./fi-edit-object-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-edit-object-dialog' },
    standalone: false,
})
export class FiEditObjectDialogComponent
    extends FiDialogsContentBase<IEditObjectDialogData, IEditObjectDialogDataItem>
    implements OnInit, OnDestroy
{
    changedItem: IEditObjectDialogDataItem;
    selectedTabIndex: number;
    isDirty = false;

    private fiDialogsService: FiDialogsService;
    private appTextService: AppTextService;
    fiValuesComparison: FiValuesComparison<IEditObjectDialogDataItem>;

    @ViewChild(FiValidatingFormDirective) editObjectForm: FiValidatingFormDirective;

    ngOnInit() {
        this.setServices();
        this.setChangedItemData();
        this.subscribeOnTransitionCloseDialog(this.fiDialogsService, this.ngOnDestroy$);
    }

    private setChangedItemData() {
        this.changedItem = JSON.parse(JSON.stringify(this.data.item));
    }

    getResult(): IEditObjectDialogDataItem {
        return this.changedItem;
    }

    onValueChanged() {
        this.editObjectForm.updateValidity();
        this.isDirty = true;
    }

    isYesButtonDisabled(): boolean {
        return !!this.editObjectForm.errors;
    }

    getNoButtonClickPromise(): Promise<{ canClose: boolean }> {
        return this.fiDialogsService.getCanCloseConfirmation(!this.isDirty, {
            headerText: this.appTextService.get('common.confirm_leave_dialog_header'),
            messageText: this.appTextService.get('common.confirm_leave_dialog_message'),
            yesButtonText: this.appTextService.get('common.leave'),
            noButtonText: this.appTextService.get('common.confirm_leave_dialog_keep_edit'),
        });
    }

    private setServices() {
        this.fiDialogsService = this.injector.get(FiDialogsService);
        this.appTextService = this.injector.get(AppTextService);
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
